// extracted by mini-css-extract-plugin
export default {"root":"ForgotConfirm_root__63SIQ","form":"ForgotConfirm_form__eaep5"};